import React from 'react';
import { FlameIcon } from 'lucide-react';
import { CtaBlock } from './CtaBlock';
import { PRODUCT_IMAGE, stats } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden border-b border-ink-700 bg-ink-950" data-id="element-142" data-mp="9ktc3i8tpsv4">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-brand/10 blur-[90px]" aria-hidden="true" data-id="element-143" data-mp="9ip7sz70irub" />
      <div className="relative mx-auto w-full max-w-5xl px-4 pb-10 pt-5 sm:px-6 sm:pb-14 sm:pt-8" data-id="element-144" data-mp="12a0it4iflorg">
        <div className="mx-auto flex w-fit items-center gap-2 rounded-full border border-brand/40 bg-brand/10 px-3 py-1.5" data-id="element-145" data-mp="xa4hjd14cbfl">
          <FlameIcon className="h-3.5 w-3.5 text-brand" aria-hidden="true" data-id="element-146" data-mp="s9zwrat6gujk" />
          <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-brand sm:text-xs" data-id="element-147" data-mp="nczr3108ptsz">
            Einführungsangebot · Lebenslanger Zugang für 19 €
          </span>
        </div>

        <h1 className="mt-6 text-center font-display text-[34px] uppercase leading-[0.98] text-white sm:text-6xl" data-id="element-148" data-mp="381xjaspbqs7j">
          Meister-
          <span className="text-brand" data-id="element-149" data-mp="3j923tk0h7itf">Schweisssystem</span>
          <span className="align-super text-base sm:text-2xl" data-id="element-150" data-mp="3o85ata00nz41">™</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-semibold leading-snug text-white sm:text-2xl" data-id="element-151" data-mp="39albailw2w59">
          Hör auf zu improvisieren und erhalte starke und saubere Schweißnähte
        </p>

        <p className="mx-auto mt-3 max-w-2xl text-center text-[15px] leading-relaxed text-white/65 sm:text-base" data-id="element-152" data-mp="30hhp9lx6haz0">
          Vergiss Versuch und Irrtum, verwirrende Einstellungen und endlose Videos. Das
          Meister-System führt dich Schritt für Schritt dabei, deine Maschine richtig einzustellen,
          Anfängerfehler zu vermeiden und von deinen ersten Übungen an mit Selbstvertrauen zu
          schweißen.
        </p>

        <img src={PRODUCT_IMAGE} alt="Meister-Schweißsystem — 6 Handbücher, Boni und digitaler Zugang" className="mx-auto mt-6 w-full max-w-lg" width={1080} height={1080} data-id="element-153" data-mp="2hkghxug5iyrw" />

        <CtaBlock id="hero-cta" label="Ich will das Meister-System jetzt" className="mt-2" data-id="element-154" data-mp="s44j7qwfvrjh" />

        <ul className="mx-auto mt-6 flex max-w-xl flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[12px] font-medium text-white/70 sm:text-sm" data-id="element-155" data-mp="ibypabmmn01n">
          {['Sofortiger Zugang', 'Einmalige Zahlung', 'Lebenslanger Zugang', '7 Tage Garantie'].map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-156" data-mp="162uc0uc87521">
              <span className="text-brand" aria-hidden="true" data-id="element-157" data-mp="112g5xhu6q56n">
                ✓
              </span>
              {item}
            </li>)}
        </ul>
      </div>

      <div className="border-t border-ink-700 bg-ink-900" data-id="element-158" data-mp="x3h260k6wegs">
        <div className="mx-auto grid w-full max-w-5xl grid-cols-2 gap-px overflow-hidden bg-ink-700 sm:grid-cols-4" data-id="element-159" data-mp="3ltqbtahzursg">
          {stats.map(stat => <div key={stat.label} className="bg-ink-900 px-3 py-5 text-center" data-id="element-160" data-mp="1x9b0knlp8d68">
              <p className="font-display text-2xl text-brand sm:text-3xl" data-id="element-161" data-mp="1x7hv3bmtnyzt">{stat.value}</p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white/55 sm:text-[11px]" data-id="element-162" data-mp="218tntq0zt0c8">
                {stat.label}
              </p>
            </div>)}
        </div>
      </div>

      <p className="mx-auto max-w-3xl px-4 py-6 text-center text-[15px] font-medium leading-relaxed text-white/75 sm:text-lg" data-id="element-163" data-mp="2b2kcaux4darx">
        Mehr als ein Kurs… ein Nachschlagewerk für jedes Mal, wenn du schweißen willst.
      </p>
    </header>;
}